import { Observable } from 'rxjs';
import {
  TimelineUiOnlyViewSettings,
  TimelineViewSettings,
  toTimelineUiOnlyViewSettings,
} from '@ardoq/timeline2024';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { getFilteredViewSettings$ } from 'views/filteredViewSettings$';
import { GenericInstanceViewSettings } from 'views/environmentals/viewSettings/types';
import { shallowEqual } from 'utils/objectUtils';

export const getTimelineViewSettings$ = (
  viewSettings$: Observable<GenericInstanceViewSettings<TimelineViewSettings>>
): Observable<TimelineViewSettings> =>
  getFilteredViewSettings$(viewSettings$).pipe(
    map(({ currentSettings }) => currentSettings)
  );

export const getUiOnlyViewSettings$ = (
  streamWithChanges$: Observable<
    GenericInstanceViewSettings<TimelineViewSettings>
  >
): Observable<TimelineUiOnlyViewSettings> =>
  streamWithChanges$.pipe(
    map(({ currentSettings }) => toTimelineUiOnlyViewSettings(currentSettings)),
    distinctUntilChanged(shallowEqual)
  );
